
import { Options, Vue } from 'vue-class-component'
import CONTACTS from '@/data/contact'
import Tree from 'primevue/tree'

@Options({
  components: {
    Tree,
  },
})
export default class Contacts extends Vue {
  expandedKeys: any = {}
  loading = false

  nodes = [
    {
      key: 0,
      label: '📫 Contacts. Click to see!',
      // leaf: false,
      children: [],
    },
  ]

  onNodeExpand() {
    // this.fetch()
  }

  clickTree() {
    this.fetch()
    if (this.expandedKeys[this.nodes[0].key] === false) {
      this.expandedKeys = {}
    } else {
      this.expandedKeys[this.nodes[0].key] = true
    }
  }

  fetch() {
    if (this.nodes[0].children.length > 0) {
      return
    }

    this.loading = true

    setTimeout(() => {
      // @ts-ignore
      this.nodes[0].children = CONTACTS
      this.loading = false
    }, 1000)
  }
}
